import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, compose, withHandlers } from 'recompose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'
import { isGoogleScopesPending, isGmailConnected } from 'app/modules/user/selectors'

import Email from './component'

const mapStateToProps = (state, props) => ({
  email: PlaybookSelectors.getEmail(state, props),
  lastEmailId: PlaybookSelectors.getLastEmailId(state),
  isMarketingSequencePlaybook: PlaybookSelectors.getIsMarketingSequencePlaybook(state),
  isOutboundSequencePlaybook: PlaybookSelectors.getIsOutboundSequencePlaybook(state),
  senderEmailOverride: PlaybookSelectors.sequenceSenderEmailOverride(state),
  sendFromOverride: PlaybookSelectors.sequenceSendFromOverride(state),
  authorId: PlaybookSelectors.sequenceAuthorId(state),
  dynamicAccountSendAttribute: PlaybookSelectors.sequenceDynamicSendAttribute(state),
  dynamicSenderFormat: PlaybookSelectors.sequenceDynamicSenderFormat(state),
  sendTestEmailLoading: PlaybookSelectors.getSendTestEmailLoading(state),
  sendTestEmailId: PlaybookSelectors.getSendTestEmailId(state),
  isGoogleScopesPending: isGoogleScopesPending(state),
  isGmailConnected: isGmailConnected(state),
  editSenderLevel: PlaybookSelectors.getEditSenderLevel(state),
  isAutomatedMarketingEmail: PlaybookSelectors.getIsAutomatedMarketingEmailPlaybook(state),
  showOneClickScheduling: UserPropertiesSelectors.properties(state).get('hasSequenceCalendarInjection', false),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setMessage: PlaybookActions.setMessage,
      setEmailDelay: PlaybookActions.setEmailDelay,
      deleteEmail: PlaybookActions.deleteEmail,
      moveEmailUp: PlaybookActions.moveEmailUp,
      setEmailMessage: PlaybookActions.setEmailMessage,
      setEmailTitle: PlaybookActions.setEmailTitle,
      setSenderName: PlaybookActions.setSequenceSenderName,
      setAuthorId: PlaybookActions.setSequenceAuthorId,
      setEmailOverride: PlaybookActions.setSequenceEmailOverride,
      sendTestEmail: PlaybookActions.sendTestEmail,
      showGoogleAuthModal: PlaybookActions.showGoogleAuthModal,
      setThreadedWithPrevious: PlaybookActions.setThreadedWithPrevious,
      setSequenceIndividualSenderName: PlaybookActions.setSequenceIndividualSenderName,
      setSequenceIndividualEmailOverride: PlaybookActions.setSequenceIndividualEmailOverride,
      savePlaybookFailed: PlaybookActions.savePlaybookFailed,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    isLastEmail: props.id === props.lastEmailId,
    hideDelay: !props.index && !props.isAutomatedMarketingEmail,
  })),
  withHandlers({
    onDelayChange: props => event => {
      const value = Number(event.target.value)
      // TODO: change this back to min=1 one we have
      // "send me the entire test sequence" button
      const delay = Math.max(0, value)
      props.actions.setEmailDelay({ emailId: props.id, delay })
    },
    onMessageChange: props => content => {
      props.actions.setEmailMessage({ emailId: props.email.id, message: content })
    },
    onThreadedWithPreviousClick: props => () => {
      props.actions.setThreadedWithPrevious({
        emailId: props.email.id,
        threadedWithPrevious: !props.email.threadedWithPrevious,
      })
    },
    onDeleteClick: props => () => {
      props.actions.deleteEmail(props.id)
    },
    // TODO: pass onMove*Click to the child components once the bug with
    // TinyMCE is fixed where it wipes the contents of the iframe
    onMoveDownClick: props => () => {
      const { actions: { moveEmailUp }, index } = props
      moveEmailUp(index + 1)
    },
    onMoveUpClick: props => () => {
      const { actions: { moveEmailUp }, index } = props
      moveEmailUp(index)
    },
    onTitleChange: props => event => {
      // If the title is empty or is only spaces, do not allow it to save.
      const isInvalid = !event.target.value || !event.target.value.trim()

      if (isInvalid) {
        props.actions.savePlaybookFailed()
      }

      props.actions.setEmailTitle({ emailId: props.email.id, title: event.target.value, dontSave: isInvalid })
    },
    onHeadlineChange: props => newTitle => {
      // If the title is empty or is only spaces, do not allow it to save.
      const isInvalid = !newTitle || !newTitle.trim()

      if (isInvalid) {
        props.actions.savePlaybookFailed()
      }

      props.actions.setEmailTitle({ emailId: props.email.id, title: newTitle, dontSave: isInvalid })
    },
    onCardMessageChange: props => newMessage => {
      props.actions.setEmailMessage({ emailId: props.email.id, message: newMessage })
    },
    onSendTestEmailClick: props => () => {
      if (props.isGmailConnected) {
        props.actions.sendTestEmail({ emailId: props.id })
      } else {
        props.actions.showGoogleAuthModal()
      }
    },
  })
)(Email)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Email/index.js